import { ScreenUtil } from '@getgo/chameleon-react';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Redirect, Route, Switch } from 'react-router-dom';
import windowSize from 'react-window-size';
import SessionsContainer from '../Sessions/SessionsContainer';
import SessionDetailsContainer from '../../Sessions/SessionDetails/SessionDetailsContainer';
import FooterComponent from '../../../Application/Footer/FooterComponent';
import HeaderContainer from '../../../Application/Header/HeaderContainer';
import NotFoundComponent from '../../../Components/ErrorComponents/NotFoundComponent';
import { trackAdminAnalyticsDashboard } from '../../../Telemetry/Mixpanel/Features/analyticsTracker';
import { LANDING_PAGE } from '../../../Telemetry/Mixpanel/Constants/mixpanelConstants';
import { getAdminLastTenSessions } from '../../../Reducks/AdminSessions/AdminSessionsActions';
import { getAdminWebinars, getWebinarCreators } from '../../../Reducks/AdminWebinars/AdminWebinarsActions';
import './AnalyticsDashboard.css';
import RobotMessageComponent from '../../../Components/RobotMessageComponent/RobotMessageComponent';
import {
  DARK_MODE,
  DARK_MODE_VARIABLES,
  LIGHT_MODE,
  NEW_EXP_LIGHT_MODE,
  LIGHT_MODE_VARIABLES,
  RobotMessageState
} from '../../../Utils/Constants';
import { appCuesPage } from '../../../Utils/Appcues';
import cssVars from 'css-vars-ponyfill';
import AnalyticsDashboardHeader from './Header/AnalyticsDashboardHeader';
import { getAdminRecordings, getRecordingCreators } from '../../../Reducks/AdminRecordings/AdminRecordingsActions';

export class AnalyticsDashboard extends Component {
  static contextTypes = {
    t: PropTypes.func.isRequired
  };
  static propTypes = {
    windowWidth: PropTypes.number,
    windowHeight: PropTypes.number,
    reduced_user: PropTypes.object,
    requestSessions: PropTypes.func,
    match: PropTypes.object
  };
  constructor(props) {
    super(props);
    this.sessionsTips = [];
    this.recordingTips = [];
  }
  componentDidMount() {
    cssVars({
      variables: LIGHT_MODE_VARIABLES
    });
    const { history } = this.props;
    const { user, darkMode } = this.props.reduced_user;
    this.unlisten = history.listen(() => appCuesPage());
    this.props.requestSessions(user.accountKey);
    this.props.requestWebinars(user.accountKey);
    this.props.requestWebinarCreators(user.accountKey);
    this.props.requestRecordings(user.accountKey);
    this.props.requestRecordingCreators(user.accountKey);
    const { t } = this.context;
    trackAdminAnalyticsDashboard(LANDING_PAGE);
    this.recordingTips = t('tips.tipsList', { returnObjects: true })
      .sort(() => 0.5 - Math.random())
      .slice(0, 3);
    this.sessionsTips = t('tips.tipsList', { returnObjects: true })
      .sort(() => 0.5 - Math.random())
      .slice(0, 3);
    if (darkMode) {
      cssVars({
        variables: DARK_MODE_VARIABLES
      });
    }
  }

  componentWillUnmount() {
    this.unlisten();
  }

  render() {
    const isBig = ScreenUtil.isUp(ScreenUtil.M, this.props.windowWidth);
    const themeClass = this.getThemeClass();
    const { t } = this.context;
    return (
      <div className={`analyticsDashboard ${themeClass}`}>
        <div className="analyticsHeader">
          <HeaderContainer isBig={isBig} title={t('header.adminAnalytics')} />
        </div>
        <div className="analyticsContent">{this.getContentSection(isBig)}</div>
        <div className="analyticsFooter">
          <FooterComponent />
        </div>
      </div>
    );
  }

  getThemeClass() {
    const { reduced_user } = this.props;
    const isJoinOptionsEnabled =
      reduced_user.entitlements.isUnifiedExperienceEntitled && reduced_user.entitlements.isUnifiedExperienceProvisioned;
    const isUnifiedExperienceEnabled = reduced_user.entitlements.isUnifiedExperienceEnabled;
    if (!reduced_user.darkMode) {
      return isJoinOptionsEnabled && isUnifiedExperienceEnabled ? NEW_EXP_LIGHT_MODE : LIGHT_MODE;
    }
    return DARK_MODE;
  }
  getContentSection(isBig) {
    const { match, reduced_user } = this.props;
    const { user, entitlements } = reduced_user;
    const { t } = this.context;

    if (!entitlements.isOrganizerReportGenerationAllowed) {
      return <RobotMessageComponent type={RobotMessageState.NOT_FOUND_STATE} />;
    }
    return (
      <div>
        <div className="contentSection">
          {<AnalyticsDashboardHeader isBig={isBig} forceRefreshHack={t('header.adminAnalytics')} />}
          <div className="contentBody">
            <Switch>
              <Route
                path={match.url + '/sessions/:sessionKey'}
                render={() => <SessionDetailsContainer isBig={isBig} accountKey={user.accountKey} isAdmin />}
              />
              <Route
                path={match.url + '/sessions'}
                render={() => <SessionsContainer isBig={isBig} tips={this.sessionsTips} />}
              />
              <Redirect exact from={match.url + '/'} to={match.url + '/sessions'} />
              <Route component={NotFoundComponent} />
            </Switch>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(
  connect(
    state => ({
      reduced_user: state.reduced_user
    }),
    {
      requestSessions: getAdminLastTenSessions,
      requestWebinars: getAdminWebinars,
      requestWebinarCreators: getWebinarCreators,
      requestRecordings: getAdminRecordings,
      requestRecordingCreators: getRecordingCreators
    }
  )(windowSize(AnalyticsDashboard))
);



// WEBPACK FOOTER //
// ./src/GoToWebinar/Admin/AdminDashboard/AnalyticsDashboard.js